<template>
    <div class="modal show" tabindex="-1" role="dialog" @click.self="backClick">
        <div :class="'modal-dialog ' + sizeClass" role="document">
            <div class="modal-content">
                <div class="modal-header" v-if="title">
                    <h5 class="modal-title">{{title}}</h5>
                    <button type="button" class="close" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <slot />
                </div>
                <div class="modal-footer" v-if="$slots.actions">
                    <slot name="actions" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalComponent",
    props: {
        title: {
            type: String,
            required: false,
            default: ''
        },
        sizeClass: {
            type: String,
            required: false,
            default: 'modal-xl'
        },
        autoClose: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        backClick(){
            if(this.autoClose) {
                this.$emit('close');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.modal{
    display: flex;
    height: 100vh;
    position: fixed;
    width: 100vw;
    justify-content: center;
    background-color: rgba(0,0,0,.25);

    .modal-dialog{
        margin: 40px auto;
        width: 100%;
    }
}
.modal-content{
    border-radius: 12px;
    background-color: #fff;
    padding: 16px;
}
.modal-header {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1rem;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: calc(0.3rem - 1px);
    border-top-right-radius: calc(0.3rem - 1px);
    .close {
        padding: 1rem;
        margin: -1rem -1rem -1rem auto;
        background-color: transparent;
        border: 0;
        cursor: pointer;
        float: right;
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 1;
        color: #000;
        text-shadow: 0 1px 0 #fff;
        opacity: .5;
    }
}
</style>